import React from 'react';

import { Text } from '@auspost/postmaster-react';

import { ReactComponent as HappyIcon } from 'assets/happy.svg';
import { ReactComponent as HelpIcon } from 'assets/help.svg';
import { ReactComponent as LocationIcon } from 'assets/location.svg';
import { ReactComponent as NotificationIcon } from 'assets/notification.svg';
import { ReactComponent as NotificationSettingsIcon } from 'assets/notification-settings.svg';
import { ReactComponent as ParcelIcon } from 'assets/parcel.svg';
import { ReactComponent as ProfileSettingsIcon } from 'assets/profile-settings.svg';
import { ReactComponent as RedirectIcon } from 'assets/redirect-street-address.svg';
import { ReactComponent as TrashIcon } from 'assets/trash.svg';

import styles from './RowContent.module.scss';

export const ROW_CARD_ICONS = {
  location: <LocationIcon className={styles.icon} />,
  help: <HelpIcon className={styles.icon} />,
  parcel: <ParcelIcon className={styles.icon} />,
  redirect: <RedirectIcon className={styles.icon} />,
  profileSettings: <ProfileSettingsIcon className={styles.icon} />,
  notification: <NotificationIcon className={styles.icon} />,
  notificationSettings: <NotificationSettingsIcon className={styles.icon} />,
  happy: <HappyIcon className={styles.icon} />,
  trash: <TrashIcon className={styles.icon} />,
} as const;

export interface RowContentProps {
  icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  text: string;
}

const RowContent: React.FC<RowContentProps> = ({ icon, text }) => (
  <>
    {icon}
    <Text variant='body-small' weight='medium' className={styles.text}>
      {text}
    </Text>
  </>
);

export default RowContent;
